import Header from "../Header";
import Footer from "../Footer";
import { Link } from "react-router-dom";
import Join from "../Join";
import Review from "../review/review";
import SubmitVideo from "../SubmitVideo";
function Video() {


  return (
    <div>
      <Header />
      <div className="bg-black text-center">
        <div className="py-3 slider_book_text1">LATEST REVIEWS</div>
      </div>



      <div className="col-sm-5 m-auto mt-3">
        <center>
          <Review />
        </center>
      </div>

      <center>
        <div className="container col-sm-12 pb-5">
          <div className="jett_scrollmenu">

            <div className="col-sm-3 jett_scrollmenu_in">
              <div className="video_part_cont mb-4">
                <video
                  className="iframe_part3"
                  controls
                  poster="/images/new_images/3/4.png"
                >
                  <source src="https://res.cloudinary.com/dlhtt7jey/video/upload/v1755821135/Junior_s_Testimony_ncauhv.mp4" type="video/mp4" />
                  Tu navegador no soporta la etiqueta de video.
                </video>
                <div className="part2_video_cont pb-4">
                  <div className="text1_part_cont">International Event</div>
                  <div className="text2_part_cont">Reflecting on the book "Persist, Persist, Persist.</div>
                </div>
              </div>
            </div>



            <div className="col-sm-3 jett_scrollmenu_in">
              <div className="video_part_cont mb-4">
                <video
                  className="iframe_part3"
                  controls
                   poster="/images/new_images/3/5.png"
                >
                  <source src="https://res.cloudinary.com/dlhtt7jey/video/upload/v1755821120/DONE_-_Open_Doors_wzeykt.mp4" type="video/mp4" />
                  Tu navegador no soporta la etiqueta de video.
                </video>
                <div className="part2_video_cont pb-4">
                  <div className="text1_part_cont">Daring to Dream</div>
                  <div className="text2_part_cont">What life taught me about dreams</div>
                </div>
              </div>
            </div>

            <div className="col-sm-3 jett_scrollmenu_in">
              <div className="video_part_cont mb-4">
                <video
                  className="iframe_part3"
                  controls
                   poster="/images/new_images/3/6.png"
                >
                  <source src="https://res.cloudinary.com/dlhtt7jey/video/upload/v1755820964/READER_S_REACTIONS_i3meip.mp4" type="video/mp4" />
                  Tu navegador no soporta la etiqueta de video.
                </video>
                <div className="part2_video_cont pb-4">
                  <div className="text1_part_cont">Readers' Reactions</div>
                  <div className="text2_part_cont">Readers’ voices across borders</div>
                </div>
              </div>
            </div>


          </div>
        </div>

      </center>

      {/* ======================================== */}
      <SubmitVideo />
      {/* ======================================== */}



      {/* ====================== */}

      {/* ==================== */}






      <Footer />
    </div>
  )
}


export default Video